module.exports = require('./helpers/bundle-url').getBundleURL('sif1r') + "eth.28f57e49.svg";